import React, { type PropsWithChildren } from 'react';
import { AnimatePresence } from 'framer-motion';

interface AnimationWrapperProps {
  id?: string;
}

const AnimationWrapper = ({
  children,
  id,
}: PropsWithChildren<AnimationWrapperProps>): JSX.Element => {
  return (
    <div id={id}>
      <AnimatePresence
        // Disable any initial animations on children that
        // are present when the component is first rendered
        initial={false}
        // Only render one component at a time.
        // The exiting component will finish its exit
        // animation before entering component is rendered
        mode='wait'
        // Fires when all exiting nodes have completed animating out
        onExitComplete={() => null}>
        {children}
      </AnimatePresence>
    </div>
  );
};

export default AnimationWrapper;
